import React from 'react';
import { brandEmail } from '../../lib/publicHosts';
import { Shield, Mail } from 'lucide-react';

// The legacy ContentContext branding doc is per-tenant content (Sprint 9a
// moved per-tenant branding into the shell's AppLayout, sourced from
// `organizations/{activeOrgId}.branding`). The public marketing chrome
// always shows the platform brand — otherwise stale SBAJ-era CMS docs
// override the new copy.

const BRAND_NAME = 'X-One Cyber Aware';
const BRAND_TAGLINE =
    'Multi-tenant cyber awareness training, phishing simulation, and compliance reporting — built for SMBs, MSSPs, and the communities that serve them.';
const BRAND_EMAIL = brandEmail('hello');

export const Footer = () => {
    return (
        <footer className="bg-gray-100 text-gray-900 dark:bg-gray-900 dark:text-white pt-16 pb-8 transition-colors duration-300">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
                    <div>
                        <div className="flex items-center mb-6 space-x-3">
                            <Shield className="h-8 w-8 text-blue-600 dark:text-blue-400" />
                            <span className="font-bold text-xl tracking-tight text-gray-900 dark:text-white">
                                {BRAND_NAME}
                            </span>
                        </div>
                        <p className="text-gray-600 dark:text-gray-400 text-sm leading-relaxed">
                            {BRAND_TAGLINE}
                        </p>
                    </div>

                    <div>
                        <h3 className="text-lg font-semibold mb-6 text-blue-600 dark:text-blue-400">Product</h3>
                        <ul className="space-y-3 text-sm text-gray-600 dark:text-gray-400">
                            <li><a href="/how-it-works" className="hover:text-blue-600 dark:hover:text-white transition-colors">How it works</a></li>
                            <li><a href="/pricing" className="hover:text-blue-600 dark:hover:text-white transition-colors">Pricing</a></li>
                            <li><a href="/signup" className="hover:text-blue-600 dark:hover:text-white transition-colors">Get started</a></li>
                            <li><a href="/blog" className="hover:text-blue-600 dark:hover:text-white transition-colors">Blog</a></li>
                            <li><a href="/status" className="hover:text-blue-600 dark:hover:text-white transition-colors">Status</a></li>
                        </ul>
                    </div>

                    <div>
                        <h3 className="text-lg font-semibold mb-6 text-blue-600 dark:text-blue-400">Legal</h3>
                        <ul className="space-y-3 text-sm text-gray-600 dark:text-gray-400">
                            <li><a href="/terms" className="hover:text-blue-600 dark:hover:text-white transition-colors">Terms of Service</a></li>
                            <li><a href="/privacy" className="hover:text-blue-600 dark:hover:text-white transition-colors">Privacy Policy</a></li>
                            <li><a href="/dpa" className="hover:text-blue-600 dark:hover:text-white transition-colors">Data Processing Agreement</a></li>
                            <li><a href="/legal/sub-processors" className="hover:text-blue-600 dark:hover:text-white transition-colors">Sub-processors</a></li>
                            <li><a href="/legal/beta-terms" className="hover:text-blue-600 dark:hover:text-white transition-colors">Beta terms</a></li>
                        </ul>
                    </div>

                    <div>
                        <h3 className="text-lg font-semibold mb-6 text-blue-600 dark:text-blue-400">Contact</h3>
                        <ul className="space-y-3 text-sm text-gray-600 dark:text-gray-400">
                            <li className="flex items-center">
                                <Mail className="h-4 w-4 mr-3" />
                                <a href={`mailto:${BRAND_EMAIL}`} className="hover:text-blue-600 dark:hover:text-white transition-colors">
                                    {BRAND_EMAIL}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="border-t border-gray-200 dark:border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
                    <p className="text-xs text-gray-500 dark:text-gray-500">
                        &copy; {new Date().getFullYear()} {BRAND_NAME}. All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
};
